// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"e605a863","92":"2828b644","306":"be006ebc","325":"51c98190","497":"7f55de8b","781":"8294af99","784":"fbbc78e7","786":"71813f54","800":"52407f6c","852":"ddaccf2a","906":"fad19f60","977":"23840850"}[chunkId] + ".chunk.js";
};